module.exports = __webpack_public_path__ + "img/hover_list@2x.73845bdf.svg";